import {SubmissionError} from 'redux-form';
import NetworkError from './error/NetworkError';

import {unflatten} from 'flat';

const flattenErrors = object => {
  return Object.assign({}, ...function _flatten(objectBit, path = '') {
    return [].concat(
      ...Object.keys(objectBit).map(key => {
          if (key === 'children') {
            return _flatten(objectBit[key], path);
          }

          if (key === 'errors') {
            return {[path || 'errors']: objectBit[key][0]};
          }

          return _flatten(objectBit[key], `${path}${path && '.'}${key}`);
        }
      )
    )
  }(object));
};

export function asMappedSubmissionError(mappings = {}) {
  return (err) => {
    if (!(err instanceof NetworkError)) {
      throw err;
    }

    if (err.status === 400) {
      const fieldErrors = flattenErrors(err.response.errors || {});

      mappings = {...mappings, errors: '_error'};

      Object.keys(mappings).forEach((key) => {
        if (fieldErrors[key]) {
          fieldErrors[mappings[key]] = fieldErrors[key];
          delete fieldErrors[key];
        }
      });

      throw new SubmissionError({
        ...unflatten(fieldErrors),
        _error: fieldErrors._error || err.message
      });
    }

    throw new SubmissionError({_error: err.message || 'Unexpected error occurred'});
  }
}

const asSubmissionError = asMappedSubmissionError();
export default asSubmissionError;



// WEBPACK FOOTER //
// ./utils/asSubmissionError.js